module.exports = __webpack_public_path__ + "static/media/front-rg.64cfefbe.svg";